import name from './name'

const selectSliceData = state => state[name]
const selectPlans = state => selectSliceData(state).plans

export {
  selectPlans
}
